import { headerKey } from './header';

/**
 * As duas abas da planilha de itens de compra (Fase 26).
 *
 * A comparação é pela chave do nome (`headerKey`: sem acento, sem caixa, sublinhado e hífen
 * valendo espaço), e não pelo nome exato: "Itens de compra", "itens_de_compra" e "Mao de
 * obra" são as abas.
 */
export const PURCHASE_SHEETS = {
  lines: { name: 'Itens de compra', spellings: ['itens de compra', 'itens compra'] },
  labor: { name: 'Mão de obra', spellings: ['mao de obra'] },
} as const;

export interface PurchaseWorkbookDetection {
  /** O arquivo tem as duas abas — é a planilha de itens de compra inteira? */
  readonly complete: boolean;
  /** O nome da aba "Itens de compra" **como o arquivo a escreve**, para achar a matriz dela. */
  readonly linesSheetName: string | null;
  /** O nome da aba "Mão de obra" como o arquivo a escreve. */
  readonly laborSheetName: string | null;
}

/**
 * Diz se o arquivo tem as duas abas e quais são os nomes delas no arquivo. Um arquivo só com
 * a aba "Itens de compra" não é `complete`, mas `linesSheetName` vem preenchido — a tela
 * pode oferecer só a importação das linhas.
 */
export function detectPurchaseWorkbook(sheetNames: readonly string[]): PurchaseWorkbookDetection {
  const find = (spellings: readonly string[]): string | null =>
    sheetNames.find((name) => spellings.includes(headerKey(name))) ?? null;

  const linesSheetName = find(PURCHASE_SHEETS.lines.spellings);
  const laborSheetName = find(PURCHASE_SHEETS.labor.spellings);
  return {
    complete: linesSheetName !== null && laborSheetName !== null,
    linesSheetName,
    laborSheetName,
  };
}
